/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2024-07-01",
    versionChannel: "nightly",
    buildDate: "2024-07-01T00:06:47.586Z",
    commitHash: "4b849cd52a8acf42a6d38d81902bacf9580f5f71",
};
